import {UserAction, UserActionTypes} from 'store/types/userActionTypes';

export interface UsersProps {
    email: string,
    signupIp?: string,
    userId: string,
    fullName: string,
    method:string,
    usedSources: number,
    createdAt: string,
    sources?: string[],
    digestNumbers: number,
    userMailNumbers: number,
    userDigestTemplateUsage: number,
    profileImg?: any;
    subscriptionPlan?: string;
    subscriptionRecordId?: number;
    stripeSubscriptionId?: string;
    cancellationRequestedAt?: string;
    cancellationEffectiveAt?: string;
    cancelAtPeriodEnd?: boolean;
    cancellationFeedback?: string;
    cancellationComment?: string;
    cancellationReason?: string;
    isActive?: boolean;
}

interface StateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string,
    dist: number,
    usersData: UsersProps[]
}

const initialState: StateTyp = {
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    dist: 0,
    usersData: [],
};


export const users = (state = initialState, action: UserAction): StateTyp => {
    switch (action.type) {
        case UserActionTypes.FETCHING_DATA:
            return {
                ...state,
                isLoading: true,
                dist: action.payload.dist,
                usersData: [...action.payload.users],
            };
        case UserActionTypes.SET_ALL_TO_FREE_TRIAL:
            return {
                ...state,
                isLoading: true,
                successMessage: action.message,
            };

        default:
            return state;
    }
};
